export const IconMoney = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconMoney_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconMoney_svg__a)">
        <path d="M14 13a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 11 10q0-1.25.875-2.125A2.9 2.9 0 0 1 14 7q1.25 0 2.125.875T17 10t-.875 2.125A2.9 2.9 0 0 1 14 13m-7 3q-.824 0-1.412-.588A1.93 1.93 0 0 1 5 14V6q0-.824.588-1.412A1.93 1.93 0 0 1 7 4h14q.824 0 1.413.588Q23 5.175 23 6v8q0 .825-.587 1.412A1.93 1.93 0 0 1 21 16zm2-2h10q0-.825.587-1.412A1.93 1.93 0 0 1 21 12V8q-.824 0-1.413-.588A1.93 1.93 0 0 1 19 6H9q0 .824-.588 1.412A1.93 1.93 0 0 1 7 8v4q.824 0 1.412.588Q9 13.175 9 14m10 6H3q-.824 0-1.412-.587A1.93 1.93 0 0 1 1 18V8q0-.424.288-.713A.97.97 0 0 1 2 7q.424 0 .712.287Q3 7.576 3 8v10h16q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 19 20" />
      </g>
    </svg>
  );
};
